import { Suspense } from 'react';
import PageLoader from '@/components/pageLoader/PageLoader';
import { Outlet } from 'react-router';

const PublicLayout = () => {
  return (
    <div className="min-h-screen">
      <Suspense fallback={<PageLoader />}>
        <Outlet />
      </Suspense>
    </div>
  );
};
export default PublicLayout;
